import { z } from "zod";
export const lengthDiscountAppliedSchema = z.object({
    discount_percent: z.number().int().min(0).max(100),
    discount_cents: z.number().int().min(0),
    applied_tier_min_nights: z.number().int().min(0).nullable(),
});
